import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CopyTextSingleLineComponent } from './copy-text-single-line.component';
import { ToastModule } from 'primeng/toast';



@NgModule({
  declarations: [
    CopyTextSingleLineComponent
  ],
  imports: [
    CommonModule,
    ToastModule
  ],
  exports: [
    CopyTextSingleLineComponent
  ]
})
export class CopyTextSingleLineModule { }
